function SocialLink({ href, label }: { href: string; label: string }) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className='block py-2 px-3 hover:bg-gray-100 desktopNav:hover:bg-transparent desktopNav:border-0 desktopNav:p-0'
    >
      {label}
    </a>
  );
}

export default SocialLink;
